import script from "./TruckMapView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TruckMapView.vue?vue&type=script&setup=true&lang=ts"

import "./TruckMapView.vue?vue&type=style&index=0&id=9a1be3a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a1be3a6"]])

export default __exports__